import { createSlice } from '@reduxjs/toolkit'
import { selectCurrentHotelId } from 'accessors'

const { useSelector, useDispatch } = require('react-redux')

const initialState = JSON.parse(localStorage.getItem('messageFollowUps')) ?? {}

export const followUpSlice = createSlice({
  name: 'followUps',
  initialState,
  reducers: {
    update: (state, action) => ({ ...action.payload })
  }
})

function useMessageFollowUp() {
  const hotelId = useSelector(selectCurrentHotelId)

  const hotelDisplayId = useSelector(s => s.hotelDetails.displayId)

  const dispatch = useDispatch()

  const followUps = useSelector(s => s.followUps)

  function saveFollowUp(chatId, guestName, messagingType, note = '') {
    const savedMessageFollowUps =
      JSON.parse(localStorage.getItem('messageFollowUps')) ?? {}

    const updatedFollowUps = {
      ...savedMessageFollowUps,
      [chatId]: { chatId, guestName, note, hotelId, messagingType, hotelDisplayId }
    }

    localStorage.setItem(`messageFollowUps`, JSON.stringify(updatedFollowUps))

    dispatch(followUpSlice.actions.update(updatedFollowUps))
  }

  function deleteFollowUp(chatId) {
    const savedMessageFollowUps =
      JSON.parse(localStorage.getItem('messageFollowUps')) ?? {}

    delete savedMessageFollowUps[chatId]

    localStorage.setItem('messageFollowUps', JSON.stringify(savedMessageFollowUps))

    dispatch(followUpSlice.actions.update(savedMessageFollowUps))
  }

  return { saveFollowUp, followUps, deleteFollowUp }
}

export default useMessageFollowUp
